










































































import { SkuEditPattern, SkuColorPattern, SkuSelectionOption } from '@/model/printableSku'
import Vue from 'vue'

export default Vue.extend({
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: '選択してください'
    },
    dropDownItems: {
      type: Array,
      required: true
    },
    activeItem: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    hasDropdownItems(): boolean {
      return this.dropDownItems.length > 0
    }
  },
  methods: {
    onClickItem(item: SkuEditPattern | SkuColorPattern | SkuSelectionOption) {
      if (item.id === this.activeItem) return
      this.$emit('updateSelection', this.name, item)
    }
  }
})
